
export const FETCH_PUBLIC_TEMPLATES = "[ASSISTANT] FETCH_PUBLIC_TEMPLATES";
export const FETCH_PUBLIC_TEMPLATES_START = "[ASSISTANT] FETCH_PUBLIC_TEMPLATES_START";
export const FETCH_PUBLIC_TEMPLATES_SUCCESS = "[ASSISTANT] FETCH_PUBLIC_TEMPLATES_SUCCESS";
export const FETCH_PUBLIC_TEMPLATES_ERROR = "[ASSISTANT] FETCH_PUBLIC_TEMPLATES_ERROR";

export const ADD_UPDATE_PUBLIC_TEMPLATE = "[ASSISTANT] ADD_UPDATE_PUBLIC_TEMPLATE";
export const ADD_UPDATE_PUBLIC_TEMPLATE_START = "[ASSISTANT] ADD_UPDATE_PUBLIC_TEMPLATE_START";
export const ADD_UPDATE_PUBLIC_TEMPLATE_SUCCESS = "[ASSISTANT] ADD_UPDATE_PUBLIC_TEMPLATE_SUCCESS";
export const ADD_UPDATE_PUBLIC_TEMPLATE_ERROR = "[ASSISTANT] ADD_UPDATE_PUBLIC_TEMPLATE_ERROR";

export const DELETE_PUBLIC_TEMPLATE = "[ASSISTANT] DELETE_PUBLIC_TEMPLATE";
export const DELETE_PUBLIC_TEMPLATE_START = "[ASSISTANT] DELETE_PUBLIC_TEMPLATE_START";
export const DELETE_PUBLIC_TEMPLATE_SUCCESS = "[ASSISTANT] DELETE_PUBLIC_TEMPLATE_SUCCESS";
export const DELETE_PUBLIC_TEMPLATE_ERROR = "[ASSISTANT] DELETE_PUBLIC_TEMPLATE_ERROR";

export const SHOW_TEMPLATE_INFO_MODAL = "[ASSISTANT] SHOW_TEMPLATE_INFO_MODAL";
export const HIDE_TEMPLATE_INFO_MODAL = "[ASSISTANT] HIDE_TEMPLATE_INFO_MODAL";

export const fetchPublicTemplates = () => {
    return {
        type: FETCH_PUBLIC_TEMPLATES,
    };
}

export const addUpdatePublicTemplate = (publicTemplate) => {
    return {
        type: ADD_UPDATE_PUBLIC_TEMPLATE,
        publicTemplate
    };
}

export const deletePublicTemplate = (publicTemplate) => {
    return {
        type: DELETE_PUBLIC_TEMPLATE,
        publicTemplate
    };
}

export const showTemplateInfoModal = () => {
    return {
        type: SHOW_TEMPLATE_INFO_MODAL,
    };
}

export const hideTemplateInfoModal = () => {
    return {
        type: HIDE_TEMPLATE_INFO_MODAL,
    };
}
